import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import UserFormModal, { UserFormProps } from "components/UserFormModal";
import AuthenticationModal from "components/AuthenticationModal";
import { shouldAuthenticate } from "utils/authentication";

import { UserResource } from "@dashboard-v3/api";

interface EditButtonProps {
  user: UserResource;
  onSave: UserFormProps["onSave"];
  disabled: boolean;
}

export default function EditBtn({ onSave, user, disabled }: EditButtonProps) {
  const { t } = useTranslation("users");
  const [userFormIsOpen, setUserFormIsOpen] = useState(false);
  const [authIsOpen, setAuthIsOpen] = useState(false);
  const tooltip = disabled ? t("cannotModifyOwner") : t("common:edit");

  const onButtonClick = () => {
    if (shouldAuthenticate()) {
      setAuthIsOpen(true);
    } else {
      setUserFormIsOpen(true);
    }
  };

  const onAuthSuccess = () => {
    setAuthIsOpen(false);
    setUserFormIsOpen(true);
  };

  return (
    <>
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            data-testid="users__edit-user-btn"
            onClick={onButtonClick}
            disabled={disabled}
            size="small"
            aria-label={t("common:edit")}
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      {userFormIsOpen && (
        <UserFormModal
          isOpen={userFormIsOpen}
          onClose={() => setUserFormIsOpen(false)}
          onSave={onSave}
          user={user}
        />
      )}

      {authIsOpen && (
        <AuthenticationModal
          isOpen={authIsOpen}
          onSuccess={onAuthSuccess}
          onClose={() => setAuthIsOpen(false)}
        />
      )}
    </>
  );
}
